







import Vue from 'vue';
import AiAssistant from 'src/components/aiAssistant/aiAssistant';

export default Vue.extend({
  components: {
    AiAssistant
  },
  computed: {
    showAssistant() {
      return this.$route.name !== 'login' && this.$route.name !== 'error-404';
    }
  }
});
